import type { FeatureCollection, Geometry } from "geojson";

import { PaginationMeta } from "./pagination";

export interface GetAdminAreaPayload {
  country_id: string;
  level: number;
  parent_id?: string;
  page?: number;
  per_page?: number;
}

export interface AdministrativeArea {
  adm_unit: string;
  boundary: FeatureCollection<Geometry>;
  code: string;
  country_id: string;
  created_at: string;
  full_code: string;
  id: string;
  level: number;
  name: string;
  updated_at: string;
  zip_code: string;
  long_name: string;
  parents?: AdministrativeArea[];
}

export interface AdministrativeAreaExtract extends AdministrativeArea {
  parents: AdministrativeArea[];
}

export interface AdminAreaData {
  data: AdministrativeArea[];
  meta?: {
    pagination?: PaginationMeta;
  };
}

export enum EAdminAreaLevel {
  LEVEL_0 = "adm_area_level_0",
  LEVEL_1 = "adm_area_level_1",
  LEVEL_2 = "adm_area_level_2",
  LEVEL_3 = "adm_area_level_3",
  LEVEL_4 = "adm_area_level_4"
}

// Helper type to map enum to level keys
export type AdminAreaLevelKey = "lv0" | "lv1" | "lv2" | "lv3" | "lv4";

// Helper object to map level keys to enum values
export const ADMIN_AREA_LEVEL_MAP: Record<AdminAreaLevelKey, EAdminAreaLevel> =
  {
    lv0: EAdminAreaLevel.LEVEL_0,
    lv1: EAdminAreaLevel.LEVEL_1,
    lv2: EAdminAreaLevel.LEVEL_2,
    lv3: EAdminAreaLevel.LEVEL_3,
    lv4: EAdminAreaLevel.LEVEL_4
  };

export interface AdminAreaHierarchy {
  id: string;
  name: string;
  full_code: string;
  sub_areas?: AdminAreaHierarchy[];
}
